const LineItemWrapper =
  'grid grid-rows-[150px_auto] gap-x-4 border-t-[1px] border-solid border-black last:border-b-[1px] last:border-solid last:border-black'

const LineItemRow = {
  inline: 'grid grid-cols-[150px_auto_auto]',
  wrap: 'grid grid-cols-[150px_auto]',
  overview:
    'grid grid-cols-[150px_auto] lg:grid-cols-[150px_50%_auto_auto] xl:pr-20'
}

const LineItemContent = {
  inline: 'grid h-[150px] grid-rows-[1fr_1fr_5fr] p-8 items-center gap-2',
  wrap: 'grid h-[150px] grid-rows-[1fr_1fr_5fr] p-4 items-center gap-4'
}

const LineItemProductDescription = {
  inline:
    'lineitem-product-description text-mediumGray text-14 w-4/5 overflow-hidden text-ellipsis whitespace-nowrap',
  wrap: 'lineitem-product-description text-mediumGray text-14 w-full overflow-hidden text-ellipsis whitespace-nowrap'
}

export {
  LineItemWrapper,
  LineItemContent,
  LineItemRow,
  LineItemProductDescription
}
